import React, { useContext } from 'react';
// import { Avatar, Button } from 'antd';
import Avatar from 'react-avatar';
import { AppContext } from '../../../Contexts/App/AppContext';
import '../styles/header.scss'
function DropDownAvatar(props) {
    const appCtx = useContext(AppContext);
    const profileName = appCtx.userDetails && appCtx.userDetails.user ? appCtx.userDetails.user.username : "U";
    const profileThumbnail = appCtx.userDetails && appCtx.userDetails.user ? appCtx.userDetails.user.user_image_thumbnail : null;
    return (
        <>
            {
                profileThumbnail ?
                    <div className="avatar-top-bar" onClick={e => props.onClick(e)}>
                        <img src={`${profileThumbnail}?${new Date().getTime()}`} alt="Menu" className="top-bar-image" />
                    </div> :
                    <Avatar
                        name={profileName}
                        size="32"
                        className="avatar-top-bar"
                        color='#804ddf'
                        // style={{ verticalAlign: 'middle' }}
                        onClick={e => props.onClick(e)}
                    />
            }
        </>
    );
}

export default DropDownAvatar;